import { render, staticRenderFns } from "./SettlementMethod.vue?vue&type=template&id=55855c54&scoped=true&"
import script from "./SettlementMethod.vue?vue&type=script&lang=js&"
export * from "./SettlementMethod.vue?vue&type=script&lang=js&"
import style0 from "./SettlementMethod.vue?vue&type=style&index=0&id=55855c54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55855c54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
